
































































































































































































































































































































































































































































































import Vue from 'vue'

export default Vue.extend({
    name: 'Started',
    data: () => ({
        step: 1,
        step1Selected: -1,
        step2Selected: -1,
        step3Selected: -1,
        step1: [
            {
                title: "Timber Frame, Low Roof Pitch",
                image: "icons/House_1.jpg",
                text: "Low roof pitch, timber-framed house with metal roof cladding"
            },
            {
                title: "Timber Frame, Medium Roof Pitch",
                image: "icons/House_2_High_Set.jpg",
                text: "Medium roof pitch, timber-framed house with metal roof cladding"
            },
            {
                title: "Low-set Brick Veneer",
                image: "icons/House_3_Brick_Veneer.jpg",
                text: "Low-set house with brick veneer wall construction "
            },
            {
                title: "Low-set Double Brick",
                image: "icons/House_4_Double_Brick.jpg",
                text: "Low-set house with double brick wall construction "

            }
        ],
        step2a: [
            {
                title: "Tile Roof",
                image: "icons/Tile_Roof.jpg",
                text: "Tile Roof"
            },
            {
                title: "Metal Roof",
                image: "icons/Metal_Roof.jpg",
                text: "Metal Roof"
            }
        ],
        step2b: [
            {
                title: "High-Set",
                image: "icons/House_2_High_Set.jpg",
                text: "High-Set"
            },
            {
                title: "Low-Set",
                image: "icons/House_2_Low_Set.jpg",
                text: "Low-Set"
            }
        ],
        step3: [
            {
                title: "Region A",
                color: "#D1D4C5"
            },
            /*{
                title: "Region B",
                color: "#4FC3F7"
            },*/
            {
                title: "Region B or C",
                color: "#366E85"
            },
            /*{
                title: "Region D",
                color: "#044577"
            }*/
        ]
    }),
    computed: {
        currentTitle () {
            switch (this.step) {
                case 1: return 'First, select your house type';
                case 2: return 'Select a feature of your house';
                case 3: return 'In which wind region is your house located? ';
                default: return 'Retrofit Detail'
            }
        },
        step1Select () {
            if (this.step1Selected == 2 || this.step1Selected == 3)
                return true;
            else
                return false;
        },
        result (){
            if (this.step1Selected===1 && this.step2Selected=== 1)
                return (this.step1Selected+1) + 'a';
            if (this.step1Selected===2 && this.step2Selected=== 0)
                return (this.step1Selected+1) + 'tile';
            if (this.step1Selected===3 && this.step2Selected=== 0)
                return (this.step1Selected+1) + 'tile';
            //if (this.step1Selected===2)
            //    return (this.step1Selected+1) + 'a';
            return this.step1Selected+1;
        }
    },
    methods: {
        special(){
            if (this.step1Selected==0){
                this.step=this.step+2;
                this.step2Selected=0;
            }
            else{
                this.step++;
            }
        }
    }
})
